import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { SiteProvider } from "@/lib/site";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import NotificationOptIn from "@/components/site/NotificationOptIn";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Work from "@/pages/Work";
import Contact from "@/pages/Contact";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import NotFound from "@/pages/NotFound";
import Checkout from "@/pages/Checkout";
import AdminApp from "@/admin/AdminApp";
import ClientProject from "@/pages/ClientProject";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicLayout = () => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1"><Outlet /></main>
    <Footer />
    <ChatWidget />
    <NotificationOptIn />
  </div>
);

const AuthPage = ({ children }) => (
  <div className="min-h-screen grid place-items-center px-4 py-10 grid-lines">{children}</div>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <SiteProvider>
          <ScrollTop />
          <Routes>
            <Route path="/projects/:id" element={<ClientProject />} />
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:id" element={<ServiceDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/work" element={<Work />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/checkout/:id" element={<Checkout />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
            <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
            <Route path="/admin/*" element={<AdminApp />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </SiteProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
